import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { RenderNavItem } from "../components/RenderNavItem";
import { CarParkingLeftMenuList, UiThemeBlueColor } from "../utils/constants";

const Car_Parking_Rate_Chart = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {CarParkingLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="inner-title">
                  <h3 className="fontSizeClass">
                    {t(
                      "Chart of Rates for Day and Night Parking ( 2022- 2023)"
                    )}
                  </h3>
                </div>
                <div id="accordion">
                  <div className="card">
                    <div className="card-header" id="heading1">
                      <button
                        class="btn btn-link fontSizeClass "
                        data-toggle="collapse"
                        data-target="#collapse1"
                        aria-expanded="true"
                        aria-controls="collapse1"
                      >
                        I. {t("Rate Chart for Day Parking (7 A.M. - 10 P.M.)")}
                      </button>
                    </div>
                    <div
                      id="collapse1"
                      className="collapse show"
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 fontSizeClass">
                        <div className=" health-dept-table">
                          <table
                            width="95%"
                            border={0}
                            align="center"
                            cellPadding={2}
                            cellSpacing={2}
                            className="table table-bordered officials"
                          >
                            <tbody>
                              <tr
                                bgcolor={UiThemeBlueColor}
                                tabIndex={0}
                                align="center"
                                valign="middle"
                              >
                                <td
                                  width="25%"
                                  rowSpan={3}
                                  className="text-white tble-brder-left"
                                >
                                  {t("Category of Parking space")}
                                </td>
                                <td
                                  colSpan={3}
                                  className="text-white tble-brder-right"
                                >
                                  {t("Rate per hour or part thereof (in Rs.)")}
                                </td>
                              </tr>
                              <tr
                                bgcolor={UiThemeBlueColor}
                                tabIndex={0}
                                align="center"
                                valign="middle"
                              >
                                <td
                                  colSpan={3}
                                  className="text-white tble-brder-right"
                                >
                                  {t("Type of vehicle")}
                                </td>
                              </tr>
                              <tr
                                bgcolor={UiThemeBlueColor}
                                tabIndex={0}
                                align="center"
                                valign="middle"
                              >
                                <td width="25%" className="text-white">
                                  {t("Two Wheeler (Motorized)")}
                                </td>
                                <td width="25%" className="text-white">
                                  {t("Car / Van / Mini bus")}
                                </td>
                                <td
                                  width="25%"
                                  className="text-white tble-brder-right"
                                >
                                  {t("Bus / Lorry")}
                                </td>
                              </tr>
                              <tr tabIndex={0} align="center" valign="top">
                                <td>{t("All Category")}</td>
                                <td>5</td>
                                <td>10</td>
                                <td>20</td>
                              </tr>
                            </tbody>
                          </table>
                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading2">
                      <button
                        class="btn btn-link fontSizeClass "
                        data-toggle="collapse"
                        data-target="#collapse2"
                        aria-expanded="true"
                        aria-controls="collapse2"
                      >
                        II. {t("Rate Chart for Night parking")} (10 P.M. - 7
                        A.M.)
                      </button>
                    </div>
                    <div
                      id="collapse2"
                      className="collapse "
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 fontSizeClass">
                        <div className=" health-dept-table">
                          <table
                            width="95%"
                            border={0}
                            align="center"
                            cellPadding={2}
                            cellSpacing={2}
                            className="table table-bordered officials"
                          >
                            <tbody>
                              <tr
                                bgcolor={UiThemeBlueColor}
                                tabIndex={0}
                                align="center"
                                valign="middle"
                              >
                                <td
                                  width="25%"
                                  rowSpan={3}
                                  className="text-white tble-brder-left"
                                >
                                  {t("Category of Parking space")}
                                </td>
                                <td
                                  colSpan={3}
                                  className="text-white tble-brder-right"
                                >
                                  {t("Rate per night in Rs.")}
                                </td>
                              </tr>
                              <tr
                                bgcolor={UiThemeBlueColor}
                                tabIndex={0}
                                align="center"
                                valign="middle"
                              >
                                <td
                                  colSpan={3}
                                  className="text-white tble-brder-right"
                                >
                                  {t("Type of vehicle")}
                                </td>
                              </tr>
                              <tr
                                bgcolor={UiThemeBlueColor}
                                tabIndex={0}
                                align="center"
                                valign="middle"
                              >
                                <td width="25%" className="text-white">
                                  {t("Two Wheeler (Motorized)")}
                                </td>
                                <td width="25%" className="text-white">
                                  {t("Car / Van / Mini bus")}
                                </td>
                                <td
                                  width="25%"
                                  className="text-white tble-brder-right"
                                >
                                  {t("Bus / Lorry")}
                                </td>
                              </tr>
                              <tr tabIndex={0} align="center" valign="top">
                                <td>{t("All Category")}</td>
                                <td>10</td>
                                <td>30</td>
                                <td>60</td>
                              </tr>
                            </tbody>
                          </table>
                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading3">
                      <button
                        class="btn btn-link fontSizeClass "
                        data-toggle="collapse"
                        data-target="#collapse3"
                        aria-expanded="true"
                        aria-controls="collapse3"
                      >
                        III.
                        {t(
                          "Rate Chart for Exclusive car parking by KMC itself-For 24 Hours"
                        )}
                      </button>
                    </div>
                    <div
                      id="collapse3"
                      className="collapse "
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 fontSizeClass">
                        <p className="fontSizeClass">
                          {t("Rs.30,000/- per car per annum")}.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading4">
                      <button
                        class="btn btn-link fontSizeClass "
                        data-toggle="collapse"
                        data-target="#collapse4"
                        aria-expanded="true"
                        aria-controls="collapse4"
                      >
                        IV. {t("Rate Chart for Night Parking(by KMC itself)")}
                      </button>
                    </div>
                    <div
                      id="collapse4"
                      className="collapse "
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 fontSizeClass">
                        <div className=" health-dept-table">
                          <table
                            width="95%"
                            border={0}
                            align="center"
                            cellPadding={2}
                            cellSpacing={2}
                            className="table table-bordered officials"
                          >
                            <tbody>
                              <tr
                                bgcolor={UiThemeBlueColor}
                                tabIndex={0}
                                style={{ color: "white", fontWeight: "bold" }}
                                align="center"
                                valign="middle"
                              >
                                <td className="text-white tble-brder-left">
                                  {t("Sl. No")}.
                                </td>
                                <td className="text-white">{t("Category")}</td>
                                <td
                                  colSpan={2}
                                  className="text-white tble-brder-right"
                                >
                                  {t("Per vehicle Per Month")}
                                </td>
                              </tr>
                              <tr tabIndex={0} align="center" valign="top">
                                <td>1</td>
                                <td>
                                  {t(
                                    "Upto four Wheelers(Taxi/Ola/Uber/Private Cars etc)"
                                  )}
                                </td>
                                <td colSpan={2}>500.00</td>
                              </tr>
                              <tr tabIndex={0} align="center" valign="top">
                                <td>2</td>
                                <td>{t("Public carriers/LGV")}</td>
                                <td colSpan={2}>600.00</td>
                              </tr>
                              <tr tabIndex={0} align="center" valign="top">
                                <td>3</td>
                                <td>{t("Bus/Lorry/HGV")}</td>
                                <td colSpan={2}>1000.00</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading5">
                      <button
                        class="btn btn-link fontSizeClass "
                        data-toggle="collapse"
                        data-target="#collapse5"
                        aria-expanded="true"
                        aria-controls="collapse5"
                      >
                        V.
                        {t(
                          "Rate Chart for Park-O-Mat (Rowdan St. site) of KMC"
                        )}
                      </button>
                    </div>
                    <div
                      id="collapse5"
                      className="collapse "
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 fontSizeClass">
                        <p className="fontSizeClass">
                          {t(
                            "The parking fees of the Park-O-Mat will be Rs35/- per hour(for four wheelers; for both day and night) and Rs 11/-per hour(for two wheelers; for both day and night)"
                          )}
                          <br />
                          {t(
                            "The rate for parking fees of the Park-O-Mat on monthly basis will be Rs 3,450/- (for 24 hours)"
                          )}
                          <br />
                          {t(
                            "Rs 2,300/-for 12 hours during day time and Rs.1,725/- for 12 hours during night time(for four wheelers)"
                          )}
                          <br />
                          {t(
                            "The rate for parking fees of the Park-O-Mat on monthly basis for two wheelers will be Rs 1,150/- for 12 hour during day time and Rs. 900/- for 12 hours during night time"
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading6">
                      <button
                        class="btn btn-link fontSizeClass "
                        data-toggle="collapse"
                        data-target="#collapse6"
                        aria-expanded="true"
                        aria-controls="collapse6"
                      >
                        VI.
                        {t(
                          "Rate Chart for Exclusive car parking by KMC itself"
                        )}
                        -{t("(For Day only :7 A.M to 10 P.M)")}
                      </button>
                    </div>
                    <div
                      id="collapse6"
                      className="collapse "
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 fontSizeClass">
                        <p className="fontSizeClass">
                          {t("Rs.24,000/- per car per annum")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <p className="fontSizeClass">
                  {t(
                    "N.B : IT and other charges will be applicable as per norms in case of Sl No III,IV and V. It has also been decided & directed by the KMC Authority to convey that no schedule of rates will be changed in this matter"
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Car_Parking_Rate_Chart;
